import { axiosInstance } from "../axios";

export const phieuChamDiemHHApi = {
  create: async (body) => {
    return await axiosInstance.post("/goods-evaluation-forms", body);
  },
  getAll: async (params) => {
    return await axiosInstance.get("/goods-evaluation-forms", {
      params,
    });
  },
  getById: async (id) => {
    return await axiosInstance.get(`/goods-evaluation-forms/${id}`);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/goods-evaluation-forms/${id}`, body);
  },
  remove: async (id) => {
    return await axiosInstance.delete(`/goods-evaluation-forms/${id}`);
  },
  getGoodById: async (id) => {
    return await axiosInstance.get(`/goods-evaluation-forms/good/${id}`);
  },
  updateGood: async (id, body) => {
    return await axiosInstance.put(`/goods-evaluation-forms/good/${id}`, body);
  },
};
